import { render } from "./ModView.vue?vue&type=template&id=b3a5052e&scoped=true&ts=true"
import script from "./ModView.vue?vue&type=script&lang=ts"
export * from "./ModView.vue?vue&type=script&lang=ts"

import "./ModView.vue?vue&type=style&index=0&id=b3a5052e&lang=scss"
import "./ModView.vue?vue&type=style&index=1&id=b3a5052e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a5052e"]])

export default __exports__